import { ICourseModule } from '@/shared/ICourseModule';
import { ApiService } from './ApiService';
import { StorageCacheService } from './StorageCacheService';
import { TelemetryClientService } from './TelemetryClientService';

export class CourseModuleStorageService {

  public static async getCourseModules(courseId: string, force?: boolean): Promise<ICourseModule[]> {

    const cached = StorageCacheService.getValue<ICourseModule[]>(`course/${courseId}/modules`);
    if (!force && cached) {
      return cached;
    }

    const results = await ApiService.fetch<ICourseModule[]>(`/api/course/${courseId}/modules`);

    StorageCacheService.resetCache(`course/${courseId}/modules`);
    StorageCacheService.resetCache(`course/${courseId}/files`);
    StorageCacheService.setValue(`course/${courseId}/modules`, results);
    return results;
  }

  public static async getCourseModule(courseId: string, moduleId: string, action: string, force?: boolean): Promise<ICourseModule> {

    const cached = StorageCacheService.getValue<ICourseModule>(`course/${courseId}/modules/${moduleId}`);
    if (!force && cached && action !== 'new') {
      return cached;
    }

    const result = await ApiService.fetch<ICourseModule>(`/api/course/${courseId}/modules/${moduleId}/${action}`);
    StorageCacheService.setValue(`course/${courseId}/modules/${moduleId}`, result);
    return result;
  }

  public static async putCourseModule(courseId: string, courseModule: ICourseModule, moduleDataProperty: keyof ICourseModule, filename: string, nextStatus: string) {

    if (!filename) {
      TelemetryClientService.error(`Trying to save readonly module for course ${courseId}, module ${courseModule.id}`);
      return;
    }

    const data = courseModule[moduleDataProperty];
    if (!data) {
      TelemetryClientService.error(`Trying to save empty module for course ${courseId}, module ${courseModule.id}`);
      return;
    }

    await ApiService.fetch(`/api/course/${courseId}/modules/${courseModule.id}`, 'PUT', { data, filename, nextStatus });

    if (nextStatus) {
      StorageCacheService.resetCache(`course`);
    }
    StorageCacheService.setValue(`course/${courseId}/modules/${courseModule.id}`, courseModule);
  }
}
